import Navigation from './Navigation'
import programmerLogo from '../imgs/programmer.svg'
import '../css/Home.css';
import Typewriter from 'typewriter-effect';
import resumeIcon from '../imgs/resume-icon.svg'
import LinkedinIcon from '../imgs/linkedin-icon.svg'
import GithubIcon from '../imgs/github-icon.svg'
import Resume from '../imgs/resume.pdf'

function Home(){
    return(
        <div className="Home">
        <Navigation/>
        <body className="Home-body">
          <img src={programmerLogo} className="Home-logo" alt="girl on computer" />
          <h1 className="Home-header-text">
            <Typewriter 
              options={{
                strings: ['Hi, I\'m Avery'],
                autoStart: true,
                loop: true,
                pauseFor: 10000,
              }} />
          </h1>
          <p className='Home-subtitle-text'>
            Software Engineer @ <a className='Home-link' href='https://www.checkhq.com/'>Check</a>
          </p>
          <span className='Home-icon-span'>
            <a href={Resume} target="_blank" rel="noreferrer">
              <img src={resumeIcon} className='Home-icon' alt="resume" />
            </a>
            <a href="https://www.linkedin.com/in/avyhuang/" target="_blank" rel="noreferrer">
              <img src={LinkedinIcon} className='Home-icon' alt="linkedin" />
            </a>
            <a href="https://github.com/avhhh" target="_blank" rel="noreferrer">
              <img src={GithubIcon} className='Home-icon' alt="github" />
            </a>
          </span>
        </body>
        <div className="Footer">
          <p className='Footer-text'>Designed and developed by Avery Huang.</p>
        </div>      
      </div>        
    )
}

export default Home;